import BorderCard from "../components/BorderCard";

const NoLeadsSkeleton = () => {
  const Skeleton = ({ className = "" }) => (
    <div className={`bg-gray-200/80 rounded-md ${className}`} />
  );

  return (
    <div className="w-full gap-4 flex h-[calc(100dvh-171px)]">
      {/* ================= LEFT ================= */}
      <div className="flex flex-col gap-4 w-[34%]">
        {/* Profile */}
        <BorderCard className="rounded-2xl" padding="p-2.5">
          <div className="flex gap-2.5 w-full">
            <Skeleton className="w-12 h-12 rounded-full" />

            <div className="flex flex-col w-full gap-2">
              <div className="flex justify-between items-center">
                <div className="flex flex-col gap-1">
                  <Skeleton className="h-3 w-28" />
                  <Skeleton className="h-2.5 w-36" />
                </div>

                <div className="flex gap-2">
                  <Skeleton className="w-5 h-5 rounded-full" />
                  <Skeleton className="w-5 h-5 rounded-full" />
                </div>
              </div>

              <div className="border border-gray-100" />

              <div className="flex justify-between">
                <Skeleton className="h-6 w-20 rounded-lg" />
                <Skeleton className="h-6 w-20 rounded-lg" />
                <Skeleton className="h-6 w-20 rounded-lg" />
              </div>
            </div>
          </div>
        </BorderCard>

        {/* Triggers */}
        <div className="h-[calc(100dvh-300px)]">
          <BorderCard>
            <Skeleton className="h-4 w-20" />
            <Skeleton className="h-7 w-16 rounded-md" />
          </BorderCard>

          <BorderCard
            variant="bottom"
            padding="px-0 py-0"
            className="h-[calc(100dvh-378px)] overflow-hidden"
          >
            <div className="flex flex-col w-full">
              {[...Array(6)].map((_, i) => (
                <div
                  key={i}
                  className="flex justify-between items-center px-4 py-6 border-b border-gray-200"
                >
                  <div className="flex gap-2 items-center">
                    <Skeleton className="w-4 h-4 rounded" />
                    <Skeleton className="h-3 w-24" />
                  </div>

                  <div className="flex gap-2 items-center">
                    <Skeleton className="h-4 w-14 rounded-full" />
                    <Skeleton className="w-4 h-4 rounded-full" />
                  </div>
                </div>
              ))}
            </div>
          </BorderCard>
        </div>
      </div>

      {/* ================= RIGHT ================= */}
      <div className="w-[66%] relative">
        <BorderCard>
          <Skeleton className="h-4 w-40" />
          <Skeleton className="h-8 w-28 rounded-md" />
        </BorderCard>

        <BorderCard
          variant="bottom"
          className="h-[calc(100dvh-232px)] overflow-hidden"
        >
          <div className="px-5 flex flex-col w-full items-center">
            {[...Array(4)].map((_, index) => (
              <div key={index} className="flex flex-col w-full items-center">
                <Skeleton className="h-20 w-[80%] rounded-xl" />

                {index !== 3 && (
                  <>
                    <div className="w-px h-8 border-l border-dashed border-gray-300" />
                    <Skeleton className="h-10 w-40 rounded-full" />
                    <div className="w-px h-6 border-l border-dashed border-gray-300" />
                    <Skeleton className="h-8 w-24 rounded-full" />
                    <div className="w-px h-8 border-l border-dashed border-gray-300" />
                  </>
                )}
              </div>
            ))}
          </div>
        </BorderCard>
      </div>
    </div>
  );
};

export default NoLeadsSkeleton;
